import { Routes } from '@angular/router';

export enum MyAccountRouteNames {
  EDIT = 'edit',
  CHANGE_PASSWORD = 'change-password',
}

export const MY_ACCOUNT_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('@pages/my-account/my-account-data/my-account-data.page').then((p) => p.MyAccountDataPage),
  },
  {
    path: MyAccountRouteNames.EDIT,
    loadComponent: () => import('@pages/my-account/my-account-edit/my-account-edit.page').then((p) => p.MyAccountEditPage),
    data: {
      breadcrumb: 'ACTIONS.EDIT_ACCOUNT',
    },
  },
  {
    path: MyAccountRouteNames.CHANGE_PASSWORD,
    loadComponent: () =>
      import('@pages/my-account/my-account-change-password/my-account-change-password.page').then((p) => p.MyAccountChangePasswordPage),
    data: {
      breadcrumb: 'ACTIONS.CHANGE_PASSWORD',
    },
  },
];
